import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import AcceleratorPage from "@/pages/AcceleratorPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminSubmissions from "@/pages/AdminSubmissions";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/accelerator" element={<AcceleratorPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/submissions" element={<AdminSubmissions />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
